// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2Th0s","inline":"Icon_inline__eEzFY","svg":"Icon_svg__2YJrO"};